import { api } from './api';

/** Estado da integração com a Comunidade Xtreed. */
export interface CommunityStatus {
  enabled: boolean;
  apiUrl: string;
  webUrl: string;
}

/** Espaço da comunidade, achatado a partir da árvore de categorias. */
export interface CommunitySpace {
  id: string;
  slug: string;
  name: string;
  emoji: string | null;
  type: string;
  locked: boolean;
  category: string;
}

/** Vínculo resolvido para uma aula: qual espaço abrir e de onde ele veio. */
export interface CommunityLink {
  spaceSlug: string;
  source: 'course' | 'module';
}

export interface CommunityLinkParams {
  productId?: string;
  moduleId?: string;
}

class CommunityServiceApi {
  async getStatus(): Promise<CommunityStatus> {
    const { data } = await api.get('/community/status');
    return data?.data || data;
  }

  async getSpaces(): Promise<CommunitySpace[]> {
    const { data } = await api.get('/community/spaces');
    return data?.data || data || [];
  }

  async getLink(params: CommunityLinkParams): Promise<CommunityLink | null> {
    const { data } = await api.get('/community/link', { params });
    // "Sem vínculo" chega como { success: true, data: null }: o `||` usado nos
    // outros services devolveria o envelope inteiro, então desembrulha pela chave.
    const payload =
      data && typeof data === 'object' && 'data' in data ? data.data : data;
    return payload ?? null;
  }
}

export const communityService = new CommunityServiceApi();
